<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-proceeds page-operative-data-analysis-proceeds-new">
    <div class="container">
      <div class="d-flex align-items-center justify-content-between mb-5">
        <PageTitle>Nuovo ricavo</PageTitle>
        <app-router-link class="btn btn-outline-primary" :to="{ name: 'operative-company.data-analysis.proceeds' }">Torna alla lista</app-router-link>
      </div>

      <FormRicavo v-if="company && userCanEdit" @saved="saveRicavo" />
      <div v-else-if="company">Utente non abilitato</div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '@/mixins/operativePage';

export default {
  name: 'page-operative-company-data-analysis-proceeds-new',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('@/views/components/Layout/LayoutOperative/PageTitle'),
    FormRicavo: () => import('@/views/components/Operative/Form/FormRicavo'),
    AppRouterLink: () => import('@/views/components/Layout/AppRouterLink'),
  },
  methods: {
    saveRicavo (ricavo) {
      this.$api.addRicavo(this.company.id, ricavo)
        .then(() => {
          this.$router.push({
            name: 'operative-company.data-analysis.proceeds',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
};

</script>
